import getUsers from './getUsers';
import putBlockUser from './putBlockUser';
import postLogOut from './postLogOut';

export default {
  getUsers,
  putBlockUser,
  postLogOut,
};
